import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {DataTable} from "primereact/datatable";
import axios from "axios";
import {Column} from "primereact/column";
import {Toast} from "primereact/toast";
import {Button} from "primereact/button";
import Spinner from "../../spinner/Spinner";
import AddFlavor from "./AddFlavor";
import {Dialog} from "primereact/dialog";
import {confirmPopup} from "primereact/confirmpopup";
import {InputText} from "primereact/inputtext";


const Flavors = props => {
    const toast = useRef(null);
    const [flavors, setFlavors] = useState([]);
    const [loadingState, setLoadingState] = useState(false);
    const [addFlavorDialog, setAddFlavorDialog] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const flavor_list_role = localStorage.getItem("cloud_flavor_list") ? true : false;
    const flavor_add_role = localStorage.getItem("cloud_flavor_add") ? true : false;
    const flavor_update_role = localStorage.getItem("cloud_flavor_update") ? true : false;
    const flavor_delete_role = localStorage.getItem("cloud_flavor_delete") ? true : false;

    useEffect(() => {
        getFlavors();
    }, []);

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const getFlavors = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/cloud-flavor-admin/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        ////console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setFlavors(data.flavors);
                            showSuccess("Şablonlar listelendi");
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const deleteFlavor = (flavor_id) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            if (flavor_id === null) {
                showError("Şablon ID Seçilemedi");
                return;
            }
            headers["Authorization"] = `Token ${token}`;
            setLoadingState(true)
            fetch("/api/cloud-flavor/" + flavor_id, {headers, method: "DELETE"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        const data = res.data;
                        if (data.result) {
                            showSuccess(data.message);
                            getFlavors();
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }

    }

    const deleteFlavorConfirm = (e, flavor_id) => {
        confirmPopup({
            target: e.currentTarget,
            message: 'Silmek istediğinize emin misiniz?',
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Evet',
            acceptIcon: 'pi pi-check',
            rejectLabel: 'Hayır',
            rejectIcon: 'pi pi-times',
            accept() {
                deleteFlavor(flavor_id);
            },
            reject() {

            }
        });
    }

    const getFlavorBody = (compute_key, compute_name) => {
        const flavorBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return flavorBody;
    }

    const processBody = (rowData) => {
        return (
            <React.Fragment>
                <div className="p-grid">
                    <div className="p-col-12" align="center">
                        <span className="p-column-title">İŞLEVLER</span>
                    </div>
                    <div className="p-col-12" align="center">
                        <div className='p-grid'>
                            <div className="p-col-12">
                                {flavor_delete_role
                                    ?
                                    <Button className='p-button-text p-button-danger'
                                            icon='pi pi-trash'
                                            onClick={(e) => deleteFlavorConfirm(e, rowData.flavor_id)}
                                    />
                                    :
                                    null
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    const getHeader = (value) => {
        return (
            <div align="center">{value}</div>
        );
    }

    const addFlavorDialogOnHide = () => {
        setAddFlavorDialog(false);
    }

    const reset = () => {
        setGlobalFilter('');
    }

    const tableHeader = (
        <div className="table-header">
            <div className="p-grid">
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-8 p-xl-8">
                    <h4><b>KULLANIMA HAZIR ŞABLONLAR</b></h4>
                </div>
                <div className="p-col-12 p-sm-12 p-md-2 p-lg-1 p-xl-1" align="right">
                    <Button type="button" title="Filtreyi Temizle"
                            className="p-button-outlined"
                            icon="pi pi-eye-slash"
                            onClick={reset}/>
                </div>
                <div className="p-col-12 p-sm-12 p-md-4 p-lg-3 p-xl-3">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search"/>
                        <InputText type="search" value={globalFilter}
                                   onChange={(e) => setGlobalFilter(e.target.value)}
                                   placeholder="Genel Arama"/>
                    </span>
                </div>
            </div>


        </div>
    );

    if (flavor_list_role) {
        return (
            <div className='p-fluid'>
                <Toast ref={toast}/>
                <Spinner loadingState={loadingState}/>
                <div className="datatable-responsive-demo">
                    <div className='card'>
                        <div className="p-grid">
                            <div className="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-3">
                                {flavor_add_role
                                    ?
                                    null
                                    /*<Button
                                        label="Yeni Şablon Ekle"
                                        icon="pi pi-plus"
                                        className="p-button-secondary p-button-text p-button-raised"
                                        onClick={(e) => setAddFlavorDialog(true)}
                                    />*/
                                    :
                                    null
                                }

                            </div>
                            <div className="p-col-12">
                                <DataTable
                                    value={flavors}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    globalFilter={globalFilter}
                                    header={tableHeader}
                                    emptyMessage="Kayıt Bulunamadı"
                                >
                                    <Column field="name"
                                            header="Şablon Adı"
                                            body={getFlavorBody("name", "Şablon Adı")}
                                            style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                            filter
                                            filterPlaceholder="Şablon Adı"
                                    />
                                    <Column field="cpu"
                                            header="CPU"
                                            body={getFlavorBody("cpu", "CPU")}
                                            style={{textAlign: 'center', width: '5.5em'}}
                                            filter
                                            filterPlaceholder="CPU Sayısı"
                                    />
                                    <Column field="gpu"
                                            header="GPU"
                                            body={getFlavorBody("gpu", "GPU")}
                                            style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                            filter
                                            filterPlaceholder="GPU Sayısı"
                                    />
                                    <Column field="ram"
                                            header="RAM"
                                            body={getFlavorBody("ram", "RAM")}
                                            style={{textAlign: 'center', width: '5.5em'}}
                                            filter
                                            filterPlaceholder="RAM Boyutu"
                                    />
                                    <Column field="disk"
                                            header="DİSK"
                                            body={getFlavorBody("disk", "DİSK")}
                                            style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                            filter
                                            filterPlaceholder="DİSK Boyutu"
                                    />
                                    {flavor_delete_role && flavor_update_role
                                        ?
                                        null
                                        /*<Column header={getHeader("İŞLEVLER")}
                                                body={processBody}/>*/
                                        :
                                        null
                                    }

                                </DataTable>
                            </div>
                        </div>

                    </div>
                </div>

                <Dialog header="Şablon Ekle"
                        visible={addFlavorDialog}
                        style={{width: '75%'}}
                        onHide={addFlavorDialogOnHide}
                        maximizable
                >
                    <AddFlavor setAddFlavorDialog={setAddFlavorDialog} getFlavors={getFlavors}/>
                </Dialog>

            </div>
        );
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Flavors);


// WEBPACK FOOTER //
// ./src/pages/cloudmanagement/Flavors.jsx